import styled from 'styled-components'

import { Typography as CommonTypography } from 'primsell-shared-layer/components'

export const NFTDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
`

export const NFTTitle = styled(CommonTypography)`
  && {
    margin-top: 24px;
    font-size: 24px;
    font-weight: 600;
    font-style: normal;
    line-height: normal;
  }
`

export const BurnFormContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
`
